export default __webpack_public_path__ + "static/media/hero-logo-825d41cc18309b6d54cf18147ad2688a.png";